const SectionLabel = ({ as: Tag = 'p', className = '', children }) => (
    <Tag className={`text-[11px] font-semibold uppercase tracking-[0.05em] text-gray-400 ${className}`}>
        {children}
    </Tag>
);

export default SectionLabel;
